// extracted by mini-css-extract-plugin
export default {"container":"LikeButton_container__5cia+","wrapper":"LikeButton_wrapper__sB1SW","wrapper_active":"LikeButton_wrapper_active__p9kao"};